import resolveByResponseError from '../messageResolver/resolveByResponseError';
/**
 * @param {ErrorResponse} errorResponse
 * @param {?ErrorDataMessageConfig} messagesByError
 *
 * @returns {?string}
 */

export default (function (errorResponse, messagesByError) {
  if (messagesByError === null) {
    return null;
  }

  return resolveByResponseError(errorResponse, messagesByError) || null;
});